let sortedPages = (state, type) => {
  let pagesType = state.pages[type];
  let query = pagesType.query.toLowerCase() || "";
  const newPagesFiltered = state.pages[type].list
  .filter(item => {
    const id = item.id + "";
    return item?.title?.toLowerCase().includes(query) || (item?.itemsName?.toLowerCase().includes(query)) || id.includes(query);
  }).sort((a, b) => {
    return new Date(b.updated_at) - new Date(a.updated_at);
  });
  return newPagesFiltered;
};

const getters = {
  sortedArticlePages: state => {
    return sortedPages(state, "articlepages");
  },
  sortedProductPages: state => {
    return sortedPages(state, "productpages");
  },
  isNeedToUnpublishProductPage: state => publishedPageCount => {
    return publishedPageCount > state.pages['productpages'].limit;
  },
  isNeedToUnpublishArticlePage: state => publishedPageCount =>{
    return publishedPageCount > state.pages['articlepages'].limit;
  },
  mergedUnpublishedList: state => pageType => {
    const { v6: listV6, v7: listV7 } = state.pages[pageType].unpublishList;
    return [...listV6, ...listV7];
  }
};

export default getters;
